import { render, staticRenderFns } from "./SkuDetail.vue?vue&type=template&id=7383020d&scoped=true"
import script from "./SkuDetail.vue?vue&type=script&lang=js"
export * from "./SkuDetail.vue?vue&type=script&lang=js"
import style0 from "./SkuDetail.vue?vue&type=style&index=0&id=7383020d&prod&lang=less"
import style1 from "./SkuDetail.vue?vue&type=style&index=1&id=7383020d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383020d",
  null
  
)

export default component.exports